import { gql } from '@apollo/client';

const sampleEvent = gql`
  fragment sampleEvent on sample_events {
    id
    name
    description
    eventJson
  }
`;

export default sampleEvent;
